import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { ConfiguracaoService } from './configuracao/configuracao.service';
import { SecurityService } from './service';
import { MessageService } from '@mctic/ng-core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  falhouAoCarregar: boolean;
  login: string;
  message: string;

  constructor(
    private readonly configuracaoService: ConfiguracaoService,
    protected readonly securityService: SecurityService,
    private readonly keycloakService: KeycloakService,
    private readonly messageService: MessageService) {
  }

  ngOnInit() {
    this.falhouAoCarregar = false;
    this.keycloakService.isLoggedIn().then(value => {
      if (value) {
        this.keycloakService.loadUserProfile().then(user => {
          this.login = user.username;

          this.configuracaoService.initialize().subscribe(
            () => this.falhouAoCarregar = false,
            error => {
              this.falhouAoCarregar = true;
              this.message = this.messageService.findById(error).description
            }
          );
        });
      }
    });
  }

  logout() {
    this.securityService.limparSelecionadas();
    this.keycloakService.logout().then();
  }

  abrirSuporteUsuario() {
    window.open('https://suportetecnico.mctic.gov.br', '_blank');
  }
}
